export default {"src":"/_next/static/media/placeholder-6.d5e68f88.svg","height":190,"width":352};